import {
  CREATE_METER_SUCCESS,
  FETCH_METER_SUCCESS,
  GET_METER_SUCCESS,
  SAVE_METER_QUERY,
  FETCH_ASSET_METER_DETAIL_SUCCESS
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  assetMeters: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_METER_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_METER_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_METER_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_METER_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case FETCH_ASSET_METER_DETAIL_SUCCESS: {
      return {
        ...state,
        assetMeters: action.data,
      }
    }


    default:
      return state;
  }
}
